var HOURS_COLOR = [
  '#32CBCB', // HOURS_TYPE.DONE
  '#FF6531', // HOURS_TYPE.PLANNED
  '#fecb2f', // HOURS_TYPE.SHOPPING
  '#545252' // HOURS_TYPE.EMPTY
];

module.exports = HOURS_COLOR;
